import { ChangeEvent, useRef, useState } from 'react';
import { api } from '../../lib/api';
import { Button } from '../ui/Button';

export function DocumentUploadCard({ orderId, docName, onUploaded }: { orderId: string; docName: string; onUploaded?: () => void }) {
  const [status, setStatus] = useState<'idle' | 'uploading' | 'done' | 'error'>('idle');
  const [fileName, setFileName] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  async function handleFileChange(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setFileName(file.name);
    setStatus('uploading');
    try {
      await api.documents.upload(orderId, docName, file);
      setStatus('done');
      onUploaded?.();
    } catch {
      setStatus('error');
    }
  }

  return (
    <div className="flex items-center justify-between rounded border border-line bg-white p-4">
      <div>
        <p className="text-sm font-medium text-ink">{docName}</p>
        {fileName && <p className="text-xs text-ink/50">{fileName}</p>}
        {status === 'error' && <p className="text-xs text-red-600">Upload failed. Try again.</p>}
        {status === 'done' && <p className="text-xs text-ledger-green">Uploaded</p>}
      </div>

      <input
        ref={inputRef}
        type="file"
        className="hidden"
        accept=".pdf,.jpg,.jpeg,.png,.webp"
        onChange={handleFileChange}
      />
      <Button
        type="button"
        size="sm"
        variant={status === 'done' ? 'outline' : 'primary'}
        onClick={() => inputRef.current?.click()}
        disabled={status === 'uploading'}
      >
        {status === 'uploading' ? 'Uploading...' : status === 'done' ? 'Replace' : 'Upload'}
      </Button>
    </div>
  );
}
